import { useState, useEffect } from 'react';

type Language = 'zh' | 'vi';

const translations = {
  zh: {
    // 导航
    home: '首页',
    about: '关于我们',
    services: '业务范围',
    projects: '项目案例',
    contact: '联系我们',
    // 按钮
    learnMore: '了解更多',
    getQuote: '获取报价',
    contactUs: '联系我们',
    viewDetails: '查看详情',
    sendMessage: '发送消息',
    // 通用
    companyName: '惠亚建筑工程有限公司',
    slogan: '专业工业厂房建筑工程服务',
    allRightsReserved: '版权所有',
    // 表单
    name: '姓名',
    email: '邮箱',
    phone: '电话',
    message: '留言内容',
    submit: '提交',
    // 服务
    electrical: '电气工程',
    hvac: '暖通空调',
    ventilation: '通风系统',
    decoration: '建筑装饰',
    renovation: '改造工程',
    waterproofing: '防水地坪漆',
    // 优势
    professionalExperience: '专业经验',
    integratedSolution: '一体化解决方案',
    localTeam: '本地化团队',
    qualityAssurance: '质量保证',
    chineseSpecialized: '中资专业服务',
    oneStopService: '一站式服务',
  },
  vi: {
    // 导航
    home: 'Trang chủ',
    about: 'Về chúng tôi',
    services: 'Dịch vụ',
    projects: 'Dự án',
    contact: 'Liên hệ',
    // 按钮
    learnMore: 'Tìm hiểu thêm',
    getQuote: 'Nhận báo giá',
    contactUs: 'Liên hệ chúng tôi',
    viewDetails: 'Xem chi tiết',
    sendMessage: 'Gửi tin nhắn',
    // 通用
    companyName: 'Công ty TNHH Xây dựng Hueya',
    slogan: 'Dịch vụ xây dựng nhà xưởng công nghiệp chuyên nghiệp',
    allRightsReserved: 'Bảo lưu mọi quyền',
    // 表单
    name: 'Họ tên',
    email: 'Email',
    phone: 'Điện thoại',
    message: 'Nội dung tin nhắn',
    submit: 'Gửi đi',
    // 服务
    electrical: 'Công trình điện',
    hvac: 'Hệ thống HVAC',
    ventilation: 'Hệ thống thông gió',
    decoration: 'Trang trí công trình',
    renovation: 'Công trình cải tạo',
    waterproofing: 'Sơn sàn chống thấm',
    // 优势
    professionalExperience: 'Kinh nghiệm chuyên môn',
    integratedSolution: 'Giải pháp tích hợp',
    localTeam: 'Đội ngũ nội địa',
    qualityAssurance: 'Đảm bảo chất lượng',
    chineseSpecialized: 'Dịch vụ chuyên Trung Quốc',
    oneStopService: 'Dịch vụ trọn gói',
  }
};

export const useLanguage = () => {
  const [language, setLanguage] = useState<Language>('zh');

  // 从 localStorage 读取语言偏好
  useEffect(() => {
    const savedLang = localStorage.getItem('preferredLanguage') as Language;
    if (savedLang && (savedLang === 'zh' || savedLang === 'vi')) {
      setLanguage(savedLang);
    }
  }, []);

  // 保存语言偏好到 localStorage
  const changeLanguage = (lang: Language) => {
    setLanguage(lang);
    localStorage.setItem('preferredLanguage', lang);
  };

  // 翻译函数
  const t = (key: keyof typeof translations.zh): string => {
    return translations[language][key] || key;
  };

  return {
    language,
    setLanguage: changeLanguage,
    t,
    toggleLanguage: () => {
      changeLanguage(language === 'zh' ? 'vi' : 'zh');
    }
  };
};